"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar = void 0;
class Navbar {
    static init() {
        const toggleNav = document.querySelector('nav.navbar-default .navbar-toggle');
        const page = document.querySelector('html');
        if (!toggleNav || !page)
            return;
        toggleNav.addEventListener('click', () => {
            toggleNav.classList.toggle('toggle-scroll');
            page.classList.toggle('toggle-scroll');
        });
    }
}
exports.Navbar = Navbar;
